import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from 'app/shared/log/log.service';
import { Observable } from 'rxjs/Observable';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { InvoiceHistoryHttpService } from './invoice-history.http.service';
import { InvoiceHistoryVendor } from '../models/invoice-history-vendor';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class InvoiceHistoryStore {

  private invoiceEnabled: BehaviorSubject<Boolean> = new BehaviorSubject(null);

  constructor(
    private flashMessagesService: FlashMessagesService,
    private logService: LogService,
    private translateService: TranslateService,
    private invoiceHistoryHttpService: InvoiceHistoryHttpService
  ) {
    this.init();
  }

  private init(): void {
  }

  getInvoiceHistoryAgencyAuth(): Observable<any> {
    return this.invoiceHistoryHttpService.getInvoiceHistoryAgencyAuth().catch(error => {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
      this.logService.error(`Error getting Invoice History Agency: ${error}`);
      return Observable.throw(error);
    }).map(auth => {
      return auth.auth;
    });
  }

  getInvoiceHistoryPropertyAuth(): Observable<any> {
    return this.invoiceHistoryHttpService.getInvoiceHistoryPropertyAuth().catch(error => {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
      this.logService.error(`Error getting Invoice History Property: ${error}`);
      return Observable.throw(error);
    }).map(auth => {
      return auth.auth;
    });
  }

  getInvoiceHistoryEventAgencyAuth(eventId: number): Observable<any> {
    return this.invoiceHistoryHttpService.getInvoiceHistoryEventAgencyAuth(eventId).catch(error => {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
      this.logService.error(`Error getting Invoice History Event Agency: ${error}`);
      return Observable.throw(error);
    }).map(auth => {
      return auth.auth;
    });
  }

  getInvoiceHistoryEventAgencyVendorAuth(eventId: number, vendor: InvoiceHistoryVendor): Observable<any> {
    return this.invoiceHistoryHttpService.getInvoiceHistoryEventAgencyVendorAuth(eventId, vendor).catch(error => {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
      this.logService.error(`Error getting Invoice History Event Agency Vendor: ${error}`);
      return Observable.throw(error);
    }).map(auth => {
      return auth.auth;
    });
  }

  getInvoiceHistoryEventPropertyAuth(eventId: number): Observable<any> {
    return this.invoiceHistoryHttpService.getInvoiceHistoryEventPropertyAuth(eventId).catch(error => {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
      this.logService.error(`Error getting Invoice History Event Property: ${error}`);
      return Observable.throw(error);
    }).map(auth => {
      return auth.auth;
    });
  }

  loadInvoiceHistoryEnabled(): Observable<any> {
    return this.invoiceHistoryHttpService.getInvoiceHistoryEnabled().catch(error => {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_ENABLED'));
      this.logService.error(`Error getting Invoice History Enabled: ${error}`);
      return Observable.throw(error);
    }).map(enabled => {
      this.invoiceEnabled.next(enabled);
      return enabled;
    });
  }

  getInvoiceHistoryEnabled(): Observable<any> {
    if (this.invoiceEnabled.getValue()) {
      return this.invoiceEnabled.asObservable();
    } else {
      return this.loadInvoiceHistoryEnabled();
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/invoice-history.store.ts